import { Link, useNavigate } from "react-router-dom";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import { useEffect } from "react";

// import { socket, messageHandlers } from '../websockets';

import { destroyPeer } from "../p2p";

function Challenge(props) {

  function userClickedCancel() {
    document.querySelector('.cover-when-loading').classList.remove('d-none');
    destroyPeer();
    navigate('/', { replace: true, });
    document.querySelector('.cover-when-loading').classList.add('d-none');
  }

  let navigate = useNavigate();

  return (
    <div className="Challenge">
      <Container fluid="md" className="d-flex flex-column justify-content-evenly align-items-center vh-100">
        <Row className="text-center gx-1 gy-1">
          <Col md={10}>
            <Form.Control type="text" readOnly value={window.location.href} />
          </Col>
          <Col md={2}>
            <Button className="my-copy-button" variant="info" onClick={() => {
              navigator.clipboard.writeText(window.location.href);
              document.querySelector('.my-copy-button').textContent = 'Done';
              setTimeout(() => {
                document.querySelector('.my-copy-button').textContent = 'Copy';
              }, 1000);
            }}>Copy</Button>
          </Col>
        </Row>;
        <Row className="text-center">
          <p className="h3 text-light">The first person to open this link will play against you.</p>
        </Row>
        <Row className="text-center">
          <Button onClick={userClickedCancel} variant="danger" size="lg">Cancel</Button>
        </Row>
      </Container>
    </div>
  );
}

export default Challenge;